import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  token: null,
  isLoggedIn: false,
  isLoading: false,
  error: null,
  userId: null,
  cartsCount: 0,
  wishsCount: 0,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = true;
    },
    setUser: (state, action) => {
      state.user = action.payload.user;
      state.isLoggedIn = true;
      state.isLoading = false;
    },
    setLogout: (state, action) => {
      state.isLoggedIn = false;
      state.user = null
    },
    setGenericUser: (state, action) => {
      state.userId = action.payload.userId;
    },
    setCartCount: (state, action) => {
      state.cartsCount = action.payload;
    },
    setWishCount: (state, action) => {
      state.wishsCount = action.payload;
    },
  },
});

export const { setUser, setGenericUser, setLogout, setCartCount, setWishCount } = authSlice.actions;
export default authSlice.reducer;
